/**
 * OVERRIDE Breadcrumbs.jsx
 * REASON: o layout do ODC 2027 não prevê breadcrumbs em página nenhuma
 * (decisão registrada em docs/found-issues.md — Geral). O App.jsx do core
 * renderiza breadcrumbs incondicionalmente; este shadow os remove do site.
 */
const Breadcrumbs = () => null;

export default Breadcrumbs;
